import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';
import theme from '../../theme.style';

export default mergeStyleSets({
  selectButton: {
    height: pxToRem(25),
    width: pxToRem(40),
    fontSize: pxToRem(16),
    textAlign: 'center',
  },
  iconColumn: {
    height: pxToRem(20),
    width: pxToRem(20),
    fontSize: pxToRem(16),
    textAlign: 'center',
    color: theme.palette.neutralTertiary,
  },
  iconColumnHeader: {
    selectors: {
      '& .ms-DetailsHeader-cellName': {
        height: pxToRem(16),
        width: pxToRem(20),
        textAlign: 'center',
        fontSize: pxToRem(16),
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        verticalAlign: 'middle',
      },
    },
  },
  downloadColumnHeader: {
    selectors: {
      '& .ms-DetailsHeader-cellName': {
        height: pxToRem(16),
        width: pxToRem(20),
        textAlign: 'center',
        fontSize: pxToRem(16),
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        verticalAlign: 'middle',
        paddingLeft: '8px',
      },
    },
  },
  infoIcon: {
    position: 'relative',
    fontSize: pxToRem(16),
    marginTop: pxToRem(2),
    float: 'right',
    color: theme.palette.themePrimary,
  },
  statement: {
    height: pxToRem(20),
    width: pxToRem(320),
    fontSize: pxToRem(14),
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    paddingRight: pxToRem(20),
    color: theme.palette.neutralDark,
  },
  downloadButton: {
    height: pxToRem(15),
    width: pxToRem(35),
  },
  payment: {
    textAlign: 'right',
    width: pxToRem(80),
  },
  paymentStatusSentIcon: {
    marginRight: pxToRem(8),
    color: theme.palette.accentTeal,
  },
  paymentStatusInProgressIcon: {
    marginLeft: pxToRem(1),
    marginRight: pxToRem(8),
    color: theme.palette.accentYellow,
  },
  paymentHeader: {
    marginTop: pxToRem(8),
  },
});
